(() => {
  const form = document.getElementById('ContactForm');
  if (!form || form.querySelector('.form-status')) return;
  const method = form.querySelector('#ContactForm-method');
  const phone = form.querySelector('#ContactForm-phone');
  const phoneRequired = form.querySelector('[data-phone-required]');
  const updateReplyMethod = () => {
    const required = method?.value === 'Telephone';
    if (phone) {
      phone.required = required;
      phone.setAttribute('aria-required', String(required));
    }
    if (phoneRequired) phoneRequired.hidden = !required;
  };
  method?.addEventListener('change', updateReplyMethod);
  updateReplyMethod();
  const params = new URLSearchParams(location.search);
  const service = params.get('service');
  if (!service) return;
  const body = form.querySelector('#ContactForm-body');
  const pest = form.querySelector('#ContactForm-pest');
  const formula = params.get('formula');
  if (body && !body.value.trim()) {
    body.value = service.slice(0, 200) + (formula && formula !== 'Default Title' ? '\n' + formula.slice(0, 200) : '') + '\n\n';
  }
  if (pest && !pest.value) {
    const option = [...pest.options].find(item => item.dataset.pestKey === params.get('pest'));
    if (option) pest.value = option.value;
  }
})();
